import Login from "./Login/Login";
import Signup from "./Signup/Signup";
import Otp from "./Otp/Otp";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ForgotPasswordReset from "./ForgotPassword/ForgotPasswordReset";

export { Login, Signup, Otp, ForgotPassword, ForgotPasswordReset };
